import { FormSubmissionDTO } from '../models/FormSubmissionDTO.model'

export const REVIEW_SUCCESS_NAV_DELAY_MS = 2000

export type DetailPageLocationState = {
  scrollToReviewId?: number
}

export function waitForReviewSuccessNavDelay(): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, REVIEW_SUCCESS_NAV_DELAY_MS)
  })
}

const reviewTypeToFormId = {
  agency: Number(process.env.REACT_APP_AGENCY_REVIEW_FORM_ID) || 35,
  hospital: Number(process.env.REACT_APP_HOSPITAL_REVIEW_FORM_ID) || 34,
}

export type ReviewEntityType = 'hospital' | 'agency'

export function formIdToReviewType(formId: number): ReviewEntityType | 'unknown' {
  if (formId === reviewTypeToFormId.hospital) return 'hospital'
  if (formId === reviewTypeToFormId.agency) return 'agency'
  return 'unknown'
}

export function getEntityDetailPathFromReviewType(reviewType: ReviewEntityType, entityId: string | number): string {
  const segment = reviewType === 'hospital' ? 'hospitals' : 'agencies'
  return `/${segment}/${entityId}`
}

export function getEntityDetailPathFromSubmission(submission: FormSubmissionDTO): string | null {
  if (submission.hospitalId) {
    return `/hospitals/${submission.hospitalId}`
  }
  if (submission.agencyId) {
    return `/agencies/${submission.agencyId}`
  }
  return null
}

export function scrollToReviewOnDetailPage(reviewId: number): boolean {
  const el = document.getElementById(`review-${reviewId}`)
  if (!el) {
    return false
  }

  const pageRoot = document.getElementById('page-root')
  if (pageRoot && pageRoot.contains(el)) {
    const parentHeight = pageRoot.getBoundingClientRect().height
    let yOffset = parentHeight * 0.2 * -1
    if (yOffset > -100) {
      yOffset = -100
    }
    const y = el.getBoundingClientRect().top + pageRoot.scrollTop + yOffset
    pageRoot.scrollTo({ behavior: 'smooth', top: Math.max(0, y) })
  } else {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  el.classList.add('review-scroll-highlight')
  window.setTimeout(() => {
    el.classList.remove('review-scroll-highlight')
  }, 2000)

  return true
}

export function scrollToReviewsSectionOnDetailPage(): void {
  const section = document.getElementById('detail-page-reviews')
  if (!section) {
    return
  }
  const pageRoot = document.getElementById('page-root')
  if (pageRoot && pageRoot.contains(section)) {
    const parentHeight = pageRoot.getBoundingClientRect().height
    let yOffset = parentHeight * 0.2 * -1
    if (yOffset > -100) {
      yOffset = -100
    }
    const y = section.getBoundingClientRect().top + pageRoot.scrollTop + yOffset
    pageRoot.scrollTo({ behavior: 'smooth', top: Math.max(0, y) })
  } else {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

export function applyScrollToReviewFromLocationState(
  scrollToReviewId: number,
  reviews: { id: number }[] | undefined,
): void {
  const hasReview = reviews?.some((r) => r.id === scrollToReviewId)
  if (hasReview && scrollToReviewOnDetailPage(scrollToReviewId)) {
    return
  }

  if (process.env.NODE_ENV === 'development') {
    console.warn(`[review scroll] Review id ${scrollToReviewId} not in list; scrolling to reviews section.`)
  }
  scrollToReviewsSectionOnDetailPage()
}
